import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: Home,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'product/:id',
        name: 'product-detail',
        component: Home
      }
    ]
  },
  {
    path: '/profil-info',
    name: 'UserPorile',
    component: () => import('../views/UserProfile.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'LoginView',
    component: () => import('../views/LoginView.vue'),
    meta: {
      requiresAuth: false
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const token = localStorage.getItem('token')
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'

  // Pastikan kedua syarat terpenuhi
  const isAuthenticated = token && isLoggedIn

  if (requiresAuth && !isAuthenticated) {
    // Redirect ke login jika tidak memenuhi syarat
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else if (to.path === '/login' && isAuthenticated) {
    // Redirect ke home jika sudah login tapi mencoba akses login page
    next('/')
  } else {
    next()
  }
})

export default router